import React, {useState} from 'react'
import {EyeIcon, EyeOffIcon, LockClosedIcon, LockOpenIcon} from "@heroicons/react/outline";
import Button from "../../Button";
import Field from "../Field/Field";
import {FieldAttributes} from "formik";

// Types ----

type PasswordFieldProps = {
  label?: string
  icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element
  hint?: string
  addon?: string
  lockEnabled?: boolean
}

// Component ----

function PasswordField({label, icon, hint, addon, lockEnabled = false, ...fieldProps}: FieldAttributes<any> & PasswordFieldProps) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isLocked, setIsLocked] = useState<boolean>(lockEnabled);

  return (
    <Field
      autoComplete="new-password"
      type={showPassword ? 'text' : 'password'}
      label={label}
      disabled={isLocked}
      icon={icon}
      addon={
        <div className='flex gap-2'>
          <button
            type="button"
            className="cursor-pointer focus-visible:outline-brand"
            onClick={() => setShowPassword(current => !current)}
          >
            {showPassword ? <EyeOffIcon className='w-5 h-5 text-gray-600'/> : <EyeIcon className='w-5 h-5 text-gray-600' />}
          </button>

          {lockEnabled &&
            <Button
              color={Button.colors.WHITE}
              size={Button.sizes.TINY}
              icon={isLocked ? LockOpenIcon : LockClosedIcon}
              onClick={() => setIsLocked(current => !current)}
            >
              <span className='sr-only'>{isLocked ? 'Unlock' : 'Lock'}</span>
            </Button>
          }
        </div>
      }
      {...fieldProps}
    />
  );
}

export {PasswordField};